// Multi-language translations for IncomeLands

export const translations = {
  telugu: {
    // App Navigation
    appName: 'IncomeLands',
    map: 'మ్యాప్',
    add: 'జోడించు',
    favorites: 'ఇష్టమైనవి',
    profile: 'ప్రొఫైల్',
    
    // Tabs
    forSale: 'అమ్మకానికి',
    buying: 'కొనుగోలు',
    myProperties: 'నా ప్రాపర్టీలు',
    
    // Property Types
    lands: 'భూములు',
    plot: 'ప్లాట్',
    flat: 'ఫ్లాట్',
    villa: 'విల్లా',
    farmPlot: 'వ్యవసాయ ప్లాట్',
    farmLands: 'వ్యవసాయ భూములు',
    house: 'ఇల్లు',
    
    // Chat Bot
    welcome: 'స్వాగతం! మీరు ఏ రకమైన ప్రాపర్టీని అమ్మాలనుకుంటున్నారు?',
    whatType: 'ఏ రకమైన ప్రాపర్టీ?',
    whereLocation: 'గొప్ప! లొకేషన్ ఎక్కడ ఉంది?',
    typeOrSpeak: 'టైప్ చేయండి లేదా మాట్లాడండి',
    howMuchArea: 'పరిమాణం ఎంత?',
    whatPrice: 'ధర ఎంత?',
    negotiable: 'చర్చనీయమా?',
    yes: 'అవును',
    no: 'కాదు',
    facing: 'ఫేసింగ్',
    east: 'తూర్పు',
    west: 'పడమర',
    north: 'ఉత్తరం',
    south: 'దక్షిణం',
    addPhotos: 'ఫోటోలు జోడించండి',
    camera: 'కెమెరా',
    gallery: 'గ్యాలరీ',
    skip: 'స్కిప్',
    ownerDetails: 'యజమాని వివరాలు (ఐచ్ఛికం)',
    ownerPrivacy: '⚠️ ఈ వివరాలు ఇతరులకు చూపబడవు - కేవలం మీ గుర్తు కోసం',
    ownerName: 'యజమాని పేరు',
    ownerPhone: 'యజమాని ఫోన్',
    propertyAdded: '✅ ప్రాపర్టీ విజయవంతంగా జోడించబడింది!',
    viewProperty: 'ప్రాపర్టీ చూడండి',
    addAnother: 'మరొకటి జోడించు',
    share: 'షేర్',
    
    // Units
    acres: 'ఎకరాలు',
    guntas: 'గుంటలు',
    cents: 'సెంట్లు',
    squareYards: 'చదరపు గజాలు',
    squareFeet: 'చదరపు అడుగులు',
    squareMeters: 'చదరపు మీటర్లు',
    
    // Contact Unlock
    unlockContact: 'కాంటాక్ట్ అన్‌లాక్ చేయండి',
    creditsRequired: 'క్రెడిట్స్ అవసరం',
    unlockFor: 'కోసం అన్‌లాక్',
    yourBalance: 'మీ బ్యాలెన్స్',
    addCredits: 'క్రెడిట్స్ జోడించు',
    
    // Common
    save: 'సేవ్',
    cancel: 'రద్దు',
    edit: 'సవరించు',
    delete: 'తొలగించు',
    search: 'వెతకండి',
    filter: 'ఫిల్టర్',
    sort: 'క్రమం',
    distance: 'దూరం',
    price: 'ధర',
    area: 'ప్రాంతం',
    loading: 'లోడ్ అవుతోంది...',
    submit: 'సమర్పించు',
    next: 'తదుపరి',
    back: 'వెనుకకు',
    done: 'పూర్తయింది',
    additionalInfo: 'అదనపు సమాచారం (ఐచ్ఛికం)',
    additionalInfoPlaceholder: 'ఉదా: రోడ్డు, నీరు, కరెంటు, దగ్గరలో పాఠశాలలు, అభివృద్ధి, మొదలైనవి...',
    propertyPostedSuccess: '🎉 మీ ప్రాపర్టీ విజయవంతంగా పోస్ట్ చేయబడింది!',
    yourPropertyIsLive: 'మీ ప్రాపర్టీ ఇప్పుడు లైవ్‌గా ఉంది',
    viewProperty: 'ప్రాపర్టీ చూడండి',
    editProperty: 'సవరించండి',
    addMoreDetails: 'మరిన్ని వివరాలు జోడించండి',
    upgradeToAddMore: '📄 డాక్యుమెంట్స్, వీడియోలు, ఆడియో జోడించడానికి అప్‌గ్రేడ్ చేయండి',
    premiumFeatures: 'ప్రీమియం ఫీచర్లు'
  },
  
  hindi: {
    // App Navigation
    appName: 'IncomeLands',
    map: 'मानचित्र',
    add: 'जोड़ें',
    favorites: 'पसंदीदा',
    profile: 'प्रोफ़ाइल',
    
    // Tabs
    forSale: 'बिक्री के लिए',
    buying: 'खरीद',
    myProperties: 'मेरी संपत्तियां',
    
    // Property Types
    lands: 'जमीन',
    plot: 'प्लॉट',
    flat: 'फ्लैट',
    villa: 'विला',
    farmPlot: 'फार्म प्लॉट',
    farmLands: 'खेती की जमीन',
    house: 'घर',
    
    // Chat Bot
    welcome: 'स्वागत है! आप किस प्रकार की संपत्ति बेचना चाहते हैं?',
    whatType: 'किस प्रकार की संपत्ति?',
    whereLocation: 'बढ़िया! स्थान कहाँ है?',
    typeOrSpeak: 'टाइप करें या बोलें',
    howMuchArea: 'क्षेत्रफल कितना है?',
    whatPrice: 'कीमत क्या है?',
    negotiable: 'परक्राम्य?',
    yes: 'हाँ',
    no: 'नहीं',
    facing: 'दिशा',
    east: 'पूर्व',
    west: 'पश्चिम',
    north: 'उत्तर',
    south: 'दक्षिण',
    addPhotos: 'फोटो जोड़ें',
    camera: 'कैमरा',
    gallery: 'गैलरी',
    skip: 'छोड़ें',
    ownerDetails: 'मालिक विवरण (वैकल्पिक)',
    ownerPrivacy: '⚠️ ये विवरण दूसरों को नहीं दिखाए जाएंगे - केवल आपकी याद के लिए',
    ownerName: 'मालिक का नाम',
    ownerPhone: 'मालिक का फोन',
    propertyAdded: '✅ संपत्ति सफलतापूर्वक जोड़ी गई!',
    viewProperty: 'संपत्ति देखें',
    addAnother: 'एक और जोड़ें',
    share: 'शेयर',
    
    // Units
    acres: 'एकड़',
    guntas: 'गुंटा',
    cents: 'सेंट',
    squareYards: 'वर्ग गज',
    squareFeet: 'वर्ग फुट',
    squareMeters: 'वर्ग मीटर',
    
    // Contact Unlock
    unlockContact: 'संपर्क अनलॉक करें',
    creditsRequired: 'क्रेडिट आवश्यक',
    unlockFor: 'के लिए अनलॉक',
    yourBalance: 'आपका बैलेंस',
    addCredits: 'क्रेडिट जोड़ें',
    
    // Common
    save: 'सहेजें',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    search: 'खोजें',
    filter: 'फ़िल्टर',
    sort: 'क्रमबद्ध',
    distance: 'दूरी',
    price: 'कीमत',
    area: 'क्षेत्र',
    loading: 'लोड हो रहा है...',
    submit: 'जमा करें',
    next: 'अगला',
    back: 'पीछे',
    done: 'पूर्ण',
    additionalInfo: 'अतिरिक्त जानकारी (वैकल्पिक)',
    additionalInfoPlaceholder: 'उदा: सड़क, पानी, बिजली, पास के स्कूल, विकास, आदि...',
    propertyPostedSuccess: '🎉 आपकी संपत्ति सफलतापूर्वक पोस्ट की गई!',
    yourPropertyIsLive: 'आपकी संपत्ति अब लाइव है',
    editProperty: 'संपत्ति संपादित करें',
    addMoreDetails: 'अधिक विवरण जोड़ें',
    upgradeToAddMore: '📄 दस्तावेज़, वीडियो, ऑडियो जोड़ने के लिए अपग्रेड करें',
    premiumFeatures: 'प्रीमियम सुविधाएं'
  },
  
  english: {
    // App Navigation
    appName: 'IncomeLands',
    map: 'Map',
    add: 'Add',
    favorites: 'Favorites',
    profile: 'Profile',
    
    // Tabs
    forSale: 'For Sale',
    buying: 'Buying',
    myProperties: 'My Properties',
    
    // Property Types
    lands: 'Lands',
    plot: 'Plot',
    flat: 'Flat',
    villa: 'Villa',
    farmPlot: 'Farm Plot',
    farmLands: 'Farm Lands',
    house: 'House',
    
    // Chat Bot
    welcome: 'Welcome! What type of property do you want to sell?',
    whatType: 'What type of property?',
    whereLocation: 'Great! Where is the location?',
    typeOrSpeak: 'Type or speak',
    howMuchArea: 'How much area?',
    whatPrice: 'What is the price?',
    negotiable: 'Negotiable?',
    yes: 'Yes',
    no: 'No',
    facing: 'Facing',
    east: 'East',
    west: 'West',
    north: 'North',
    south: 'South',
    addPhotos: 'Add Photos',
    camera: 'Camera',
    gallery: 'Gallery',
    skip: 'Skip',
    ownerDetails: 'Owner Details (Optional)',
    ownerPrivacy: '⚠️ These details will not be shown to others - just for your reminder',
    ownerName: 'Owner Name',
    ownerPhone: 'Owner Phone',
    propertyAdded: '✅ Property added successfully!',
    viewProperty: 'View Property',
    addAnother: 'Add Another',
    share: 'Share',
    
    // Units
    acres: 'Acres',
    guntas: 'Guntas',
    cents: 'Cents',
    squareYards: 'Square Yards',
    squareFeet: 'Square Feet',
    squareMeters: 'Square Meters',
    
    // Contact Unlock
    unlockContact: 'Unlock Contact',
    creditsRequired: 'Credits Required',
    unlockFor: 'Unlock for',
    yourBalance: 'Your Balance',
    addCredits: 'Add Credits',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    distance: 'Distance',
    price: 'Price',
    area: 'Area',
    loading: 'Loading...',
    submit: 'Submit',
    next: 'Next',
    back: 'Back',
    done: 'Done',
    additionalInfo: 'Additional Information (Optional)',
    additionalInfoPlaceholder: 'e.g: Road access, water, electricity, nearby schools, development, etc...',
    propertyPostedSuccess: '🎉 Your Property Posted Successfully!',
    yourPropertyIsLive: 'Your property is now live',
    editProperty: 'Edit Property',
    addMoreDetails: 'Add More Details',
    upgradeToAddMore: '📄 Upgrade to add Documents, Videos, Audio',
    premiumFeatures: 'Premium Features'
  }
};

// Language context hook
export const useLanguage = () => {
  const [language, setLanguage] = React.useState(() => {
    return localStorage.getItem('incomelands_language') || 'telugu';
  });
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('incomelands_language', lang);
  };
  
  return { language, t, changeLanguage };
};

import React from 'react';
